import { storeOrUpdateAtpFeed } from '@/api/titleGroup'
import { getCorporations } from '@/api/open'


export default {
    components: {},
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => ({ titles: [] })
        }
    },
    created(){
        if(this.model.titles){
            this.titles = this.model.titles.join('\n')
        }
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            corporations: [],
            loading: false,
            rules: {
                name: [{ required: true, message: '请填写标题组名称', trigger: 'change' }],
                corporation_ids: [{ required: true, message: '请选择所属主体', trigger: 'change' }],
            },
            show: false,
            titles: '',
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        }
    },
    mounted() {
        getCorporations().then(res => { this.corporations = res.data.list || [] })
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            let titles = this.titles.split('\n')
            titles = titles.filter(Boolean)
            if (titles.length < 1) {
                return this.$message.error('请填写标题')
            }
            this.model.titles = titles
        

            const data = Object.assign({}, this.model)
            // console.log('提交的数据', data)

            this.loading = true
            storeOrUpdateAtpFeed(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.model.id > 0 ? '修改成功' : '添加成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        },
        changeTextLine(val) {
            this.titles = val;
        },
    }
}
